// extracted by mini-css-extract-plugin
export default {"root":"FilePicture__root--1n4rH"};